import { render, staticRenderFns } from "./LiteratureSearchPopup.vue?vue&type=template&id=247c2ce4&scoped=true&"
import script from "./LiteratureSearchPopup.vue?vue&type=script&lang=js&"
export * from "./LiteratureSearchPopup.vue?vue&type=script&lang=js&"
import style0 from "./LiteratureSearchPopup.vue?vue&type=style&index=0&id=247c2ce4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247c2ce4",
  null
  
)

export default component.exports